import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import {reducer as reduxAsyncConnect} from 'redux-async-connect'
import {
  searchReducer as search,
  shareClassReducer as shareClass,
  familyShareClassReducer as familyShareClass,
  sectorReducer as sector,
  signupsubmitReducer as signupsubmit,
  tutorialdismissReducer as tutorialdismiss,
  compareReducer as compare,
  cartReducer as cart,
  fundsByStrategyReducer as fundsByStrategy
} from './search'

export default combineReducers({
  routing: routerReducer,
  reduxAsyncConnect,
  search,
  shareClass,
  familyShareClass,
  sector,
  signupsubmit,
  tutorialdismiss,
  compare,
  cart,
  fundsByStrategy
})
